import { useState } from "react";
import { useEffect } from "react";
import FooterGtMobile from "../../components/footer/FooterGtMobile";
import AboutPage from "../aboutPage/AboutPage";
import FaqPage from "../faqPage/FaqPage";
import ContactPage from "../contactPage/ContactPage";
import PrivacyPolicyPage from "../privacyPolicyPage/PrivacyPolicy";
import CguPage from "../cguPage/CguPage";
import CharterOfGoodConduct from "../charterOfGoodConduct/CharterOfGoodConduct";
import LegalInfoPage from "../legalInfoPage/LegalInfoPage";

function MentionLegalPage() {
  const [activePage, setActivePage] = useState("about");

  const renderContent = () => {
    switch (activePage) {
      case "faq": return <FaqPage isConnect={true} />;
      case "contact": return <ContactPage isConnect={true} />;
      case "charteGoodDrive": return <CharterOfGoodConduct isConnect={true} />;
      case "InfosLegal": return <LegalInfoPage isConnect={true} />;
      case "cgu": return <CguPage isConnect={true} />;
      case "privacy": return <PrivacyPolicyPage isConnect={true} />;
      default: return <AboutPage isConnect={true} />;
    }
  };


  return (
    <div className="pb-20">
      <ScrollToTopMentionLegalPage activePage={activePage} />
      {renderContent()}
      <FooterGtMobile setActivePage={setActivePage} activePage={activePage} />
    </div>
  )
}
export default MentionLegalPage;

function ScrollToTopMentionLegalPage({ activePage }: { activePage: string }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activePage]);

  return null;
}